import { useCallback, useEffect, useState } from 'react';
import {
	// DisabledIcon,
	IconFileInPlaylist,
	IconFileInPlaylistCheck,
	// SuccessIcon,
} from 'shared/_ui/icon';
import { useDispatch } from 'react-redux';
import { fetchEpisodesByVideoId } from 'shared/modules/episodes/actions';

type FilePlaylistIconProps = {
	fileId: string;
};

export default function FilePlaylistIcon({ fileId }: FilePlaylistIconProps) {
	// TODO: get rid of dispatch
	const dispatch = useDispatch();

	const [hasEpisodes, setHasEpisodes] = useState(false);

	const init = useCallback(async () => {
		if (fileId) {
			const docs = await dispatch(fetchEpisodesByVideoId([fileId]));
			setHasEpisodes(docs && docs.length > 0);
		}
	}, [fileId, dispatch]);

	useEffect(() => {
		init();
	}, [init]);

	const C = hasEpisodes ? IconFileInPlaylistCheck : IconFileInPlaylist;
	// const C = hasEpisodes ? SuccessIcon : DisabledIcon;
	// return <C Component={hasEpisodes ? IconFileInPlaylistCheck : IconFileInPlaylist} />;
	return <C color={hasEpisodes ? 'success' : 'disabled'} />;
}
